<script>
import VueChartJs from 'vue-chartjs';
import constants from '@/ctConstants.js';

export default {
  extends: VueChartJs.Line,
  mixins: [VueChartJs.mixins.reactiveProp],
  data: () => ({
    // Attenzione: maintainAspectRatio: false ==> Alezza 0px nei dialog
    options: {responsive: true, maintainAspectRatio: false,},
  }),
  mounted () {
    this.executeRenderChart();
  },
  methods: {
    executeRenderChart(){
      this.renderChart(this.chartData, this.options);
    }
  }
};
</script>